import React from 'react';
import { SvgProps } from '../core';

const TwitterLogo: React.FC<SvgProps> = ({
  width = 26,
  height = 21,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 26 21"
    >
      <path
        d="M26 2.48463C25.0431 2.90626 24.0163 3.19221 22.9374 3.31987C24.039 2.66395 24.8822 1.62358 25.2819 0.38771C24.2486 0.995128 23.108 1.43619 21.8927 1.67529C20.9195 0.642987 19.5353 0 17.9999 0C15.0544 0 12.6661 2.3748 12.6661 5.3021C12.6661 5.71727 12.7132 6.12276 12.8042 6.51051C8.37201 6.28916 4.44189 4.1777 1.81151 0.969275C1.3517 1.7512 1.09013 2.66231 1.09013 3.63488C1.09013 5.47496 2.03246 7.09854 3.46221 8.04843C2.58811 8.01936 1.76601 7.78026 1.04629 7.38284V7.44908C1.04629 10.0177 2.88545 12.1615 5.3241 12.6494C4.8773 12.769 4.40616 12.8352 3.91874 12.8352C3.57433 12.8352 3.24125 12.8013 2.91468 12.7366C3.59378 14.8449 5.56295 16.378 7.89603 16.42C6.07148 17.8417 3.7709 18.6866 1.27213 18.6866C0.841603 18.6866 0.41753 18.6607 0 18.6139C2.36069 20.1212 5.1633 21 8.17548 21C17.987 21 23.3502 12.9192 23.3502 5.91116L23.3323 5.22458C24.3802 4.48139 25.2867 3.54764 26 2.48463Z"
        fill="white"
      />
    </svg>
  );
};

export default TwitterLogo;
